export const SET_WECHAT_TOKEN = 'SET_WECHAT_TOKEN'

export const SET_RATE_STAR = 'SET_RATE_STAR'